/* eslint-disable no-console */
import { MetricName } from "@iventis/domain-model/model/metricName";
import { incrementMonitoringCount } from "../set-monitoring-metric";
import { MetricEvent } from "../metric-types";

export function importMapObjectMonitoringMetric(file: File, event: Partial<MetricEvent> = {}) {
    const fileExtension = file.name.split(".").pop();
    switch (fileExtension) {
        case "geojson":
        case "json":
            incrementMonitoringCount({ ...event, name: MetricName.MAP_OBJECTS_IMPORTED_GEOJSON });
            break;
        case "kml":
            incrementMonitoringCount({ ...event, name: MetricName.MAP_OBJECTS_IMPORTED_KML });
            break;
        case "kmz":
            incrementMonitoringCount({ ...event, name: MetricName.MAP_OBJECTS_IMPORTED_KMZ });
            break;
        default:
            console.warn(`Export format ${fileExtension} is not supported for monitoring`);
    }
}
